<div class="popup-container">
  <header>
    <div class="close_button" (click)="close()">x</div>
    <div class="header d-block roboto-medium">
      <label class="ms-3 mt-3 mb-3">Edit Event</label>
      
      <!-- <app-file-export-renderer style="display: inline-block;float:right; margin-top:10px; margin-right:20px" class="bg-dark text-white"></app-file-export-renderer> -->
    </div>
  </header>
  <div class="main">
    <div
        class="px-3"
        *ngIf="successMessage != null"
        class="alert alert-success alert-dismissible fade show p-2 ms-4 me-4"
        role="alert"
      >
        <button
          type="button"
          class="btn-close"
          (click)="closeNotif()"
          data-bs-dismiss="alert"
          aria-label="close"
        ></button>
        <strong>{{ successMessage }}</strong>
      </div>
  <div
        class="px-3"
        *ngIf="errorMessage != null"
        class="alert alert-danger alert-dismissible fade show p-2 ms-4 me-4"
        role="alert"
      >
        <button
          type="button"
          class="btn-close"
          (click)="closeNotif()"
          data-bs-dismiss="alert"
          aria-label="close"
        ></button>
        <strong>{{ errorMessage }}</strong>
      </div>
    <form [formGroup]="editEventForm" *ngIf="editEventForm">
    <div style="margin-top: 10px;">
        <label class="catlabel col-4 validRequired" for="eventType">Type:</label>
        <select required id="eventType" formControlName="eventType" (change)="onEventTypeSelection();emptyValidation()" [ngClass]="{'is-invalid': submitted && form['eventType'].errors }" >
          <option value="">---</option>
          <option *ngFor="let event of eventProbTypeList" [ngValue]="event">
            {{event.eventType}}
        </option>
        </select>
        <div *ngIf="submitted && form['eventType'].errors" class="invalid-feedback">
        <div class="col-4" *ngIf="form['eventType'].errors['required']">This field is required</div>
        </div>
    </div><br>
  
    <div>
        <label class="catlabel col-4 labelInline" for="plannedUnload">Planned Unload:</label>
        <div class="divInline">
          <div class="col-4"></div>
        <p  class="col-4">{{plannedUnload}}</p>
        </div>
    </div><br>
  
    <div>
        <label class="catlabel col-4" for="route">Route:</label>
        <div class="divInline">
          <div class="col-4"></div>
        <p class="col-4">{{route}}</p>
        </div>
    </div><br>
  
    <div>
        <label for="status" class="catlabel col-4 validRequired">Status:</label>
        <select required id="status" formControlName="status" [ngClass]="{'is-invalid': submitted && form['status'].errors }">
          <option value="">---</option>
          <option *ngFor="let item of statusList" [ngValue]="item">{{item.description}}</option>
        </select>
        <div *ngIf="submitted && form['status'].errors" class="invalid-feedback">
        <div class="col-4" *ngIf="form['status'].errors['required']">This field is required</div>
        </div>
    </div><br>
  
    <div>
        <label class="catlabel col-4 validRequired" for="problemType">Problem Type:</label>
        <select required id="problemType" formControlName="problemType" [ngClass]="{'is-invalid': submitted && form['problemType'].errors }">
          <option value="">---</option>
          <option *ngFor="let event of eventList" [ngValue]="event">
            {{event.description}}
        </option>
        </select>
        <div *ngIf="submitted && form['problemType'].errors" class="invalid-feedback">
        <div class="col-4" *ngIf="form['problemType'].errors['required']">This field is required</div>
        </div>
    </div><br>
  
    <div>
        <label class="catlabel col-4" for="logisticPartner">Logistics Partner:</label>
        <select formControlName="logisticPartner" id="logisticPartner">
          <option value="" >---</option>
          <option *ngFor="let lp of logisticPartnerList" [ngValue]="lp.vendorId">{{lp.shortName}}</option>
        </select>
    </div><br>
  
    <div>
      <label class="catlabel col-4" for="incidentDate">ETA Date:</label>
        <input type="date" class="datefield" name="incidentDate" id="incidentDate" [(ngModel)]="incidentDate" formControlName="incidentDate" (change)="onDateSelection()">
    </div><br>
  
    <div>
      <label class="catlabel col-4" for="incidentTime">ETA Time:</label>      
        <ngx-timepicker-field style="display: inline-block;" formControlName="incidentTime" [(ngModel)]="incidentTime" id="incidentTime" class="form-control timepicker" [format]="24" [defaultTime]="'00:00'"></ngx-timepicker-field>
    </div><br>
    <div class="d-flex align-items-center impacted-order-row">
      <label for="impactedOrderNumber" class="catlabel col-4" >Impacted Order Number</label>
      <div class="impacted-order-select-wrap">
        <mat-select
          formControlName="impactedOrderNumber"
          multiple
          class="mat-sel"
          panelClass="impacted-order-panel"
          [panelWidth]="400"
          [disableOptionCentering]="true"
          (openedChange)="onImpactedOrderPanelToggle($event)"
        >
          <mat-option class="impacted-order-search">
            <ngx-mat-select-search
              [formControl]="impactedOrderSearchCtrl"
              placeholderLabel="Search"
              noEntriesFoundLabel="No matching order found"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let order of filteredOrderNumber"
            [value]="order"
          >
            {{ order.description }}
          </mat-option>
        </mat-select>
      </div>
    </div><br>
    <div>
        <label class="catlabel col-4" for="trailer">Trailer:</label>
        <input type="text" formControlName="trailer" id="trailer" [(ngModel)]="trailer" class="trailerfield">
    </div><br>
  
    <div>
        <label class="catlabel col-4" for="comments">Comments:</label>
        <textarea style="width: 400px !important;
        max-width: 500px !important;" placeholder="Comments" id="comments" formControlName="comments" [(ngModel)]="comments"  #myInput (input)="checkChange(myInput.value)"></textarea>
      </div>
      <div class="d-flex">
        <div class="col-4"></div>
      <p id="charCounter" class="grey col-4"> Character Limit: {{maxi-ldiv}} left</p>
      </div><br>
  
      <div>
        <label class="catlabel col-4" for="lastUpdated">Last Updated:</label>
        <div class="divInline">
          <div class="col-4"></div>
        <p  class="col-4">{{lastUpdated}}</p>
        </div>
    </div><br>
  </form>
  
  <label class="catlabel col-4">Uploaded Documents: </label>
  <div class="divInline">
    <!-- <div class="col-4"></div> -->
    <!-- <div *ngFor="let doc of fetchedDocs">
      <div class="col-4"></div>
      <a (click)="download(doc.imageID,doc.fileName)" class="col-4 docList">{{doc.fileName}}</a>
      <img (click)="delete(doc.imageID)" class="dltImg" src="assets/images/icons8-delete-24.png"><br>
    </div> -->
    <table>
      <tr *ngFor="let doc of fetchedDocs">
        <td><a (click)="download(doc.imageID,doc.fileName)" class="col-4 docList">{{doc.fileName}}</a></td>
         <td><img (click)="delete(doc.imageID)" class="dltImg" src="assets/images/icons8-delete-24.png"><br></td>
      </tr>
    </table>
  <!-- <ng-template #elseBlock><p class="col-4 docList">No file choosen</p></ng-template> -->
  </div><br>
  </div>
  
  
  <div class="footer d-flex justify-content-between align-items-center fixed-bottom mt-2 py-2 ps-4">
    <button (click)="btnHandler()" *ngIf="isDeleteAccessible" class="deletebutt roboto-medium"> DELETE </button>
    <div class="d-flex">
      <input type="file" style="display: none;" multiple="true" (change)="onFileSelected($event)" accept=".xlsx,.pdf,.jpeg,.docx,.jpg,.svg,.png,.doc,.xls" #uploadDoc>
      <!-- <input type="file" style="display: none;" multiple="true" (change)="newonFileSelected($event)" accept=".xlsx,.pdf,.jpeg,.docx,.jpg,.svg,.png,.doc,.xls" #uploadDoc> -->

      <button (click)="uploadDoc.value='';uploadDoc.click()" class="submit black-button me-3 roboto-medium" >Upload Document</button>
      <!-- <button  class="submit black-button me-3 roboto-medium" >Download Document</button> -->
      <button  (click)="close()" class="cancel me-3 roboto-bold"> CANCEL </button>
      <button (click)="onSubmit()" type=submit class="submit black-button me-3 roboto-medium" >UPDATE</button>
    </div>
  
  </div>
  
</div>

